import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { Clock, Globe, Users, CalendarX } from "lucide-react";
const HerausforderungenTourismusSection = () => <IndustryChallengesI18n translationPrefix="industryTourismus" icons={[Clock, Globe, Users, CalendarX]} />;
export default HerausforderungenTourismusSection;
